<template>
	<AppDialog ref="dialog_container" dialogName="AddAllowedEmailsDialog" width="625px">
		<Col class="add-allowed-emails-dialog flex-justify-space-between">
			<div>
				<h1 class="dialog-title pl-0">Sending domain - {{ domainName }}</h1>
				<Row class="flex-justify-space-between">
					<span class="display-flex">
						<h4><b>Domain status:</b> {{ verified ? 'Verified' : 'Unverified' }}</h4>
						<v-icon class="ml-1" color="success">mdi-check-circle</v-icon>
					</span>
					<h4 @click="editDomainSetup">
						<a><u>Edit domain setup</u></a>
					</h4>
				</Row>

				<h3 class="mt-5"><b>Allowed from addresses</b></h3>
				<h5 class="med">
					Add addresses that creators can use to send emails from. Be cautious with personal emails - all creators will have the ability to
					send emails from them.
				</h5>
				<Row class="flex-align-center">
					<AppTextField class="new-email mt-6" v-model="email" outlined hide-details placeholder="john" /><span class="pt-2 pl-1">
						@{{ domainName }}
					</span>
					<span class="add-email-btn pt-2" :class="{ disabled: isEmailFieldDisabled }" @click="() => addEmail(email)">Add Email</span>
				</Row>
				<v-data-table v-if="allowedEmails.length" hide-default-header hide-default-footer :headers="headers" :items="allowedEmails">
					<template v-slot:item.actions="{ item }">
						<AppVMenu width="200" min-width="200" bottom left offset-y content-class="dropdown-menu-container">
							<template v-slot:activator="{ on }">
								<AnemicButton
									v-on="on"
									@click="(e) => e.preventDefault()"
									width="22"
									height="22"
									icon
									fab
									x-small
									class="menu-button ml-12"
								>
									<AppIcon name="three-dot-menu" width="13" class="menu-icon" />
								</AnemicButton>
							</template>
							<v-list>
								<v-list-item class="item-container" @click="deleteEmail(item)">
									<v-list-item-title>
										<span style="color: #3e495a; font-size: 14px; font-weight: 400"> Delete email </span>
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</AppVMenu>
					</template></v-data-table
				>
			</div>
			<Row class="flex-justify-center mb-5">
				<PrimaryButton class="done-btn" @click="addAllowedEmails">Done</PrimaryButton>
			</Row>
		</Col>
	</AppDialog>
</template>

<script>
import { DataTypeEvaluator } from '@ply-io/data-types';

import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
const evaluator = new DataTypeEvaluator();
const isEmail = evaluator.isEmail;

export default {
	name: 'AddAllowedEmailsToEmailDomainDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object }, domain: { type: Object } },
	computed: {
		isEmailFieldDisabled() {
			return !this.email.trim();
		},
	},
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		editDomainSetup() {
			this.dialogPromiseHandlers.resolve({ openInfo: true });

			AppDialogManagerService.closeCurrentDialog();
		},
		addEmail(email) {
			if (this.isEmailFieldDisabled) {
				return;
			}
			this.allowedEmails.push({ email: this.fullEmail(email) });
		},
		deleteEmail(email) {
			const index = this.allowedEmails.indexOf(email);
			if (index > -1) {
				this.allowedEmails.splice(index, 1);
			}
		},
		addAllowedEmails() {
			this.dialogPromiseHandlers.resolve({ emails: this.allowedEmails.map(({ email }) => email) });
			this.close();
		},
		addDomainClicked() {
			const allowedEmails = this.allowedEmails.split(',').map((email) => email.trim());
			for (const email of allowedEmails) {
				if (!isEmail(email)) {
					this.$toast.error(`Invalid email address: '${email}'`);
					return;
				}
			}
			this.dialogPromiseHandlers.resolve({ domainName: this.domainName, returnPathName: this.returnPathName, allowedEmails });
			this.close();
		},
		fullEmail(email) {
			return `${email}@${this.domainName}`;
		},
	},
	data() {
		const { domain: domainName, verified, returnPathName, list_of_allowed_emails: allowedEmails } = this.domain;
		return {
			domainName,
			verified,
			returnPathName,
			email: '',
			allowedEmails: (allowedEmails || []).map((email) => ({ email })),
			headers: [
				{ text: 'email', value: 'email' },
				{ text: 'Actions', value: 'actions', align: 'right' },
			],
		};
	},
};
</script>

<style scoped lang="scss">
.add-email-btn {
	margin-left: auto;
	padding: 5px 8px;
	gap: 10px;
	border-radius: 8px;

	color: #6060f7;
	border: solid 1px #6060f7;
	&:hover {
		cursor: pointer;
	}
	&.disabled {
		color: #b8b8b8;
		border: solid 1px #e0e0e0;
		cursor: not-allowed;
	}
}
.add-allowed-emails-dialog {
	height: 700px;
	.new-email {
		width: 190px;
	}
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;

	::v-deep {
		.v-icon {
			font-size: 16px !important;
		}
	}
}

::v-deep {
	.v-data-table__wrapper {
		overflow: auto !important;
		max-height: 100% !important;
	}
}
.menu-button {
	background: white !important;
	&:hover {
		border: 1px solid var(--forth-border-color);
	}
}

.done-btn {
	width: 140px;
	padding: 15px 0px;
}
</style>
